import { render, staticRenderFns } from "./MineDisplayWidget.vue?vue&type=template&id=231b2dde&scoped=true&"
import script from "./MineDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./MineDisplayWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b2dde",
  null
  
)

export default component.exports